import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { showModal } from 'actions/modal';
import { setCustomFieldValue } from 'actions/custom-fields';

import { isPersonalTask } from 'utils/task';
import { useCanUser } from 'shared-hooks/permission';

import { PublicPageContext } from 'context/PublicPageContext';

import FeatureAvailable from 'components/feature-available';
import CanUser from 'components/CanUser';
import CustomFields from 'components/custom-fields';
import CustomFieldsUpgradeNotice from 'components/custom-fields-upgrade-notice';

import IconCustomField from 'icons/icon-custom-field';

const TaskCustomFields = ({ id, projectId, task, fields }) => {
    const { t } = useTranslation('fields');

    const publicPageCtx = useContext(PublicPageContext);
    const isPublic = publicPageCtx?.isPublic === true;
    const isPersonal = isPersonalTask(task);
    const canEditTask = useCanUser('editTask', task.created_by);

    const handleCustomFieldChange = (fieldId, value) => {
        setCustomFieldValue('task', id, fieldId, value);
    }

    const handleCustomFieldCreateClick = () => {
        showModal('PROJECT_CONTROL_CENTER', {
            projectId,
            initialPage: 'taskFields',
            initialResource: 'create'
        });
    }

    if (isPublic || isPersonal) {
        return null;
    }

    return (
        <div className="content-panel-section section-fields" data-section="fields">
            <div className="section-head">
                <h4>
                    <span className="title-icon"><IconCustomField /></span>

                    <span className="text">{ t('Custom Fields') }</span>

                    <FeatureAvailable type="customFields">
                        <CanUser type="createCustomFields">
                            <button className="btn btn-circle btn-xxsmall btn-simple btn-icon btn-colored" onClick={handleCustomFieldCreateClick}>+</button>
                        </CanUser>
                    </FeatureAvailable>
                </h4>
            </div>

            <div className="section-body">
                <FeatureAvailable type="customFields">
                    <CustomFields
                        key={id}
                        projectId={projectId}
                        type="row-single"
                        association="task"
                        associationId={id}
                        values={fields}
                        onChange={canEditTask && handleCustomFieldChange}
                    />
                </FeatureAvailable>

                <FeatureAvailable type="customFields" reverse={true}>
                    <CustomFieldsUpgradeNotice />
                </FeatureAvailable>
            </div>
        </div>
    );
}

export default TaskCustomFields;
